import { getLevelSelector } from "./selectorHelpers.js";
import { hideRow } from "./visibility.js";

/**
 * Hides the levels of the tree beyond the root.
 *
 * @param tbody The table body containing the pages.
 */
export function hideLevels(tbody: HTMLElement): void {
	for (let i = 1; i < 10; i++) {
		hideLevel(tbody, i);
	}
}

/**
 * Hides the pages at the provided level of the tree.
 *
 * @param element The element to search for rows in.
 * @param level The current level of the tree.
 */
function hideLevel(element: HTMLElement, level: number) {
	element
		.querySelectorAll<HTMLTableRowElement>(getLevelSelector(level))
		.forEach(hideRow);
}
